import { render, staticRenderFns } from "./PricingJewellersExhibitionPrimaryLayer.vue?vue&type=template&id=5f43622d"
import script from "./PricingJewellersExhibitionPrimaryLayer.vue?vue&type=script&lang=js"
export * from "./PricingJewellersExhibitionPrimaryLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports